import { render } from "./UQNotesStep.vue?vue&type=template&id=07ef667c"
import script from "./UQNotesStep.vue?vue&type=script&lang=js"
export * from "./UQNotesStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__